<template>
	<CInfoPageTemplate
		:content-label="'订阅须知'"
		:content-text="content"
		:button-text="'立即订阅'"
		@button-click="goSubscription"
	/>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import CInfoPageTemplate from '@rebuild/components/base/CInfoPageTemplate.vue';
import { debounce } from '@/utils/api';
import { useRoute } from '@/utils/vue-api';
import { useNavigation } from '@rebuild/hooks/useNavigation';

const route = useRoute();
const { proxy } = getCurrentInstance();

const fromPreview = ref(false);
const content = ref(proxy.$t('enterprise.message-subscription.content'));

onMounted(async () => {
	const { preview } = route.query;
	if (preview) {
		fromPreview.value = true;
	}
});

const { goToModuleSubPath } = useNavigation();
const goSubscription = debounce(
	function () {
		if (fromPreview.value) return;
		goToModuleSubPath('message_subscription', 'form');
	},
	180,
	true
);
</script>
